import { LanguageManagementRepository } from '../data/language-management-repository';
import { DeleteLanguageResponse } from '../types/language-management-types';

/**
 * Delete Language Use Case
 * Deletes a global language. Returns usage info if language is in use.
 */
export class DeleteLanguageUseCase {
  constructor(private readonly repository: LanguageManagementRepository) {}

  async execute(languageId: number): Promise<DeleteLanguageResponse> {
    return this.repository.deleteLanguage(languageId);
  }
}
